import React, { ReactElement, useContext } from "react";
import "./CheckOutPayment.css";
import { ReactComponent as Tick } from "../../assets/icons/round_check.svg";
import { DateTimeInfoHeader } from "../CheckOutAddress/CheckOutAddress";
import { Raw } from "../../App";
import { currency } from "../../utilities/misc";
import { LocaleContext } from "../../AppProvider";

export const CheckOutPaymentLeft = ({
  full_payment,
  Total,
  paymentTypeHandler,
  TotalDeposit,
  depositUnavailable,
  children,
  DateComp
}: {
  full_payment: boolean;
  Total: number;
  paymentTypeHandler: (data: React.ChangeEvent<HTMLInputElement>) => void;
  TotalDeposit: number;
  depositUnavailable: boolean;
  children: string | ReactElement;
  DateComp?: ReactElement;
}) => {
  const { t, locale } = useContext(LocaleContext);

  return (
    <>
      {DateComp || <DateTimeInfoHeader />}
      <p>
        {t(
          "Book with confidence: you can reschedule for free up to 24 hours before your scheduled appointment."
        )}
      </p>
      <div className="check_out_payment_block">
        <div className="payment_type_wrapper">
          <p>{t("Payment Type")}:</p>
          {/* <div className="flex">
              <label className="flex">
                <label className={`logo center ${!full_payment ? `empty` : ``}`}>
                  {full_payment && <Tick className="img_div_contain" />}
                  <input
                    type="radio"
                    name="paymentTypeOption"
                    onChange={paymentTypeHandler}
                    value="fullType"
                  />
                </label>
                <span className="payment_type_container flex1">
                  Pay the full{" "}
                  <span className="fontBlue">€{Total.toFixed(2)}</span> now
                </span>
              </label>
            </div> */}
          <div className="flex payment_type_info_sect">
            <label className="flex">
              <label className={`logo center ${full_payment ? `empty` : ``}`}>
                {!full_payment && <Tick className="img_div_contain" />}

                <input
                  type="radio"
                  name="paymentTypeOption"
                  onChange={paymentTypeHandler}
                  value="depositType"
                />
              </label>
              <span className="payment_type_container flex1">
                <Raw>
                  {t(
                    "Only pay a deposit of {{amount}} the rest can be paid in cash or card to the cleaner",
                    {
                      "{{amount}}": `<span class="fontBlue">${
                        depositUnavailable
                          ? "..."
                          : `${currency(TotalDeposit.toFixed(2), locale)}`
                      }</span>`
                    }
                  )}
                </Raw>
              </span>
            </label>
          </div>
        </div>
        <div className="payment_method_wrapper">
          <p>{t("Payment Method")}:</p>
          <div className="flex">
            <div className="logo">
              <Tick className="img_div_contain" />
            </div>
            <div className="payment_method_container">
              <img
                src={require(`../../assets/icons/payment_methods.png`)}
                alt=""
                className="img_div_contain"
              />
            </div>
          </div>
        </div>
        <div className="checkout_card_label">
          <p>{t("Card Number")}:</p>
        </div>
        {children}
      </div>
    </>
  );
};

export default CheckOutPaymentLeft;
